import { useLang } from "@/context/LangContext";
import { STRINGS } from "@/i18n";

export default function Credentials() {
  const { lang } = useLang();
  const t = STRINGS[lang];
  return (
    <section id="credentials" data-testid="credentials-section" className="py-24 px-6 max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12 items-start border-t border-white/10">
      <div className="lg:col-span-5">
        <span className="mono-lbl text-xs text-[#a4133c] tracking-[0.2em] uppercase">{t.creds.label}</span>
        <h2 className="serif-disp text-4xl font-light mt-2 mb-6">{t.creds.title}</h2>
        <p className="text-neutral-300 text-sm leading-relaxed mb-6">
          {t.creds.para}
        </p>
        <div className="space-y-3 border-l-2 border-[#a4133c] pl-4">
          {t.creds.list.map((c) => (
            <p key={c} className="text-xs uppercase tracking-wider text-neutral-300 font-mono">{c}</p>
          ))}
        </div>
      </div>

      <div className="lg:col-span-7 border border-white/10 rounded-2xl p-8 bg-neutral-900/40">
        <h3 className="serif-disp text-2xl text-white mb-6">{t.creds.wordsTitle}</h3>
        <div data-testid="review-card" className="flex justify-center">
          <div className="rounded-xl overflow-hidden border border-white/15 shadow-xl -rotate-1 hover:rotate-0 transition-transform duration-500 max-w-sm w-full">
            <img
              data-testid="review-screenshot"
              src="/images/review1.jpg"
              alt="Real client text message review for Velvet Touch"
              loading="lazy"
              className="w-full h-auto"
            />
          </div>
        </div>
        <div data-testid="review-card-2" className="mt-6 border-t border-white/10 pt-6 text-center">
          <p className="serif-disp italic text-lg text-neutral-200 font-light">{t.creds.review2.quote}</p>
          <p className="mono-lbl text-[11px] uppercase tracking-widest text-[#c9933b] mt-3">{t.creds.review2.attr}</p>
        </div>
      </div>
    </section>
  );
}
